<h1 mat-dialog-title>{{ data?.title || 'No Title' }}</h1>
<div mat-dialog-content>
  {{ data?.content || 'No Content' }}
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close] cdkFocusInitial>Close</button>
</div>
